var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XiaoBottomModal',{attrs:{"title":"完善资料","overflowSinking":"4.25rem","visible":_vm.innerVisible},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('UserInfoForm',{on:{"user-info-saved":_vm.handleSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }